// Marquee — 21st.dev-inspired horizontal-scrolling Strip mit:
//   - smooth linear loop (duration prop)
//   - Fade-Masks an den Rändern
//   - pause-on-hover
//   - automatischer Item-Duplikation für seamless loop
//
// Verwendet im Hyperliquid Markets-Tab für Cross-Venue Funding + Whale Strip.
// CSS-Klassen leben in styles/globals.css (.marquee-wrap / .marquee-track).

import type { ReactNode } from 'react';

interface MarqueeProps {
  /** Eindeutige Items — werden für seamless Loop dupliziert (× 2). */
  items: ReactNode[];
  /** Animation-Duration in Sekunden (default 40s). */
  durationSec?: number;
  /** Gap zwischen Items in px (default 12). */
  gapPx?: number;
  /** Optional outer-Wrapper-Klassen (z.B. glass rounded-xl py-2). */
  className?: string;
}

export function Marquee({ items, durationSec = 40, gapPx = 12, className }: MarqueeProps) {
  const style = {
    '--marquee-duration': `${durationSec}s`,
    '--marquee-gap': `${gapPx}px`,
  } as React.CSSProperties;

  return (
    <div className={`marquee-wrap ${className ?? ''}`} style={style}>
      <div className="marquee-track">
        {items.map((item, i) => (
          <div key={`a-${i}`} className="shrink-0">
            {item}
          </div>
        ))}
        {/* Loop-Duplikat */}
        {items.map((item, i) => (
          <div key={`b-${i}`} className="shrink-0" aria-hidden>
            {item}
          </div>
        ))}
      </div>
    </div>
  );
}
